import clsx from "clsx";
import { useEffect, useState } from "react";
import {
  addPostToFavorites,
  addProfileToFavorites,
  isFavoritePost,
  isFavoriteProfile,
  isRegisteredAccount,
  removePostFromFavorites,
  removeProfileFromFavorites,
} from "#entities/account";

import * as styles from "./favorite-button.module.scss";

interface IFavoriteButtonProps {
  service: string;
  creatorId: string;
  postId?: string;
}

export function FavoriteButton({ service, creatorId, postId }: IFavoriteButtonProps) {
  const [isFavorite, setFavorite] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const renderKey = `${postId ?? ""}${creatorId}${service}`;

  async function favorite(unfav = false) {
    try {
      setLoading(true);
      if (!isRegisteredAccount()) {
        return
      }
      if (postId) {
        if (unfav) {
          await removePostFromFavorites(service, creatorId, postId);
        } else {
          await addPostToFavorites(service, creatorId, postId);
        }
      } else {
        if (unfav) {
          await removeProfileFromFavorites(service, creatorId);
        } else {
          await addProfileToFavorites(service, creatorId);
        }
      }
      setFavorite(!unfav);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        if (!isRegisteredAccount()) return;

        const isFav = postId ? await isFavoritePost(service, creatorId, postId) : await isFavoriteProfile(service, creatorId);
        setFavorite(isFav);
      } catch (error) {
        // TODO: better error handling
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [service, creatorId, postId]);

  return isFavorite ? (
    <button
      key={renderKey}
      className={clsx(styles.favoriteButton, styles.unfav)}
      type="button"
      disabled={isLoading}
      onClick={() => favorite(true)}
    >
      <span className={styles.favIcon}>★</span>
      <span>Unfavorite</span>
    </button>
  ) : (
    <button
      key={renderKey}
      className={styles.favoriteButton}
      type="button"
      disabled={isLoading}
      onClick={() => favorite(false)}
    >
      <span className={styles.favIcon}>☆</span>
      <span>Favorite</span>
    </button>
  );
}
